/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyOboTokenData
 */
export interface VerifyOboTokenData {
    /**
     * 
     * @type {string}
     * @memberof VerifyOboTokenData
     */
    token: string;
}

/**
 * Check if a given object implements the VerifyOboTokenData interface.
 */
export function instanceOfVerifyOboTokenData(value: object): value is VerifyOboTokenData {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function VerifyOboTokenDataFromJSON(json: any): VerifyOboTokenData {
    return VerifyOboTokenDataFromJSONTyped(json, false);
}

export function VerifyOboTokenDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyOboTokenData {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

  export function VerifyOboTokenDataToJSON(json: any): VerifyOboTokenData {
      return VerifyOboTokenDataToJSONTyped(json, false);
  }

  export function VerifyOboTokenDataToJSONTyped(value?: VerifyOboTokenData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

